import { useState, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ScreenContainer from "../../Components/ScreenContainer";
import { ThemeProperties } from "../../Theme/ThemeProperties";
import AccessGrantedEntitiesContent from "../../PagesContent/OrgSettings/ClientApiManagement/AccessGrantedEntitiesContent";

const AccessGrantedEntitiesInner = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const {
    apiKeyName = "—",
    baseEntityPluralLabel = "Entities",
  } = location.state || {};

  const handleBack = useCallback(() => navigate(-1), [navigate]);

  const subtitle = `The list of access granted ${baseEntityPluralLabel.toLowerCase()} to ${apiKeyName}`;

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      {/* Sticky Header */}
      <Box
        sx={{
          position: "sticky",
          top: "50px",
          zIndex: 1000,
          bgcolor: "#FAFAFA",
        }}
      >
        <Box
          sx={{
            px: 3,
            pt: 2,
            pb: 2,
            display: "flex",
            alignItems: "flex-start",
            gap: 1,
          }}
        >
          <ChevronLeftIcon
            sx={{
              fontSize: 26,
              color: ThemeProperties.purple,
              cursor: "pointer",
              mt: "2px",
              borderRadius: "50%",
              transition: "color 0.2s, background-color 0.2s",
              "&:hover": {
                color: ThemeProperties.dropDownPurple,
                bgcolor: ThemeProperties.purpleLight,
              },
            }}
            onClick={handleBack}
            data-testid="access-granted-back-btn"
          />

          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.75 }}>
              <Typography sx={{ fontSize: "18px", fontWeight: 400, color: "#3D4B5A", lineHeight: "24px" }}>
                Client API Management
              </Typography>
              <Typography sx={{ color: "#686868", fontSize: "18px", lineHeight: "28px" }}>
                /
              </Typography>
              <Typography sx={{ fontSize: "18px", fontWeight: 600, color: "#2E2E2E", lineHeight: "28px" }}>
                Access Granted {baseEntityPluralLabel} - {apiKeyName}
              </Typography>
            </Box>
            <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#686868" }}>
              {subtitle}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderColor: "#E4E3E3" }} />
      </Box>

      {/* Content */}
      <Box sx={{ p: 3 }}>
        <AccessGrantedEntitiesContent
          apiKeyId={id}
          baseEntityPluralLabel={baseEntityPluralLabel}
        />
      </Box>
    </Box>
  );
};

const AccessGrantedEntities = () => {
  const [pagesContent] = useState({ mounted: true });

  return (
    <ScreenContainer pagesContent={pagesContent}>
      <AccessGrantedEntitiesInner />
    </ScreenContainer>
  );
};

export default AccessGrantedEntities;
